import { Box, Chip, LinearProgress, Typography, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DynamicCatalogBuilder } from '../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { MuiStack } from '../../../components';
import { DesktopTabComponent } from '../../../components/molecules/desktopTabComponent';
import HeaderCatalogPageComponent from '../../../components/templates/headerCatalogPageUpdated';
import { ESystemName, LOCAL_STORAGE_KEYS } from '../../../constants';
import { resetState } from '../../../redux/crudSlice';
import { useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { dateFormate, isLoadingState } from '../../../utils/utils';
import CardView from '../../proprietaryWarranty/pages/proprietaryCardView';
import { SPRPagingAPICall } from '../services/apiCalls';
import { APIKeys, SpareIssueReturnKeys, viewTypeOptions } from '../services/entity';
var SpareIssueReturn = function () {
    var _crud$SpareIssueRetur;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var crud = useAppSelector(function (state) { return state.crud; });
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var storedSelectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _a = useState('list'), activeView = _a[0], setActiveView = _a[1];
    var _b = useState(false), isFilterOpen = _b[0], setFilterOpen = _b[1];
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var _c = useState(viewTypeOptions.length > 0 && isAllViewActive ? viewTypeOptions[0] : viewTypeOptions[1]), selectedListVariant = _c[0], setSelectedListVariant = _c[1];
    var getRequest = function () {
        var request = {
            "skip": 0,
            "take": 10,
            "orderby": "CreatedOn",
            "asc": -1,
            "search": null,
            "OrganizationId": "c247b74a-8222-4363-b693-0d54a710fa08",
            "ParentOrganizationId": "dc379234-1367-4613-bd19-52113048b2e6",
            "Type": "WorkPurchaseInvoice"
        };
        // {
        //     OrganizationId: storedSelectedBranch?.OrganizationId,
        //     ParentOrganizationId: storedSelectedBranch?.ParentOrganizationId,
        //     Type: "",
        //     IdentityId: selectedListVariant === "My spare issue return" ? getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)?.data?.IdentityId : undefined,
        // }
        return request;
    };
    var onToggleViewChange = function (view) {
        setActiveView(view);
    };
    var handleSelectMenu = function (listVariant) {
        setSelectedListVariant(listVariant);
    };
    var handleRowClick = function (id) {
        dispatch(resetState(APIKeys));
        navigate("/createWorkPurchaseInvoice/".concat(id, "?mode=edit"));
    };
    var customActionColumns = [{
            field: 'DocumentNumber',
            headerName: 'Issue return number',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.DocumentNumber ? "".concat(row === null || row === void 0 ? void 0 : row.DocumentNumber) : '-'; },
            minWidth: 170
        }, {
            field: 'RegNo',
            headerName: 'Registration no',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.RegNo ? "".concat(row === null || row === void 0 ? void 0 : row.RegNo) : '-'; },
            minWidth: 200
        }, {
            field: 'DocumentDate',
            headerName: 'Document Date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.DocumentDate ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.DocumentDate)) : '-'; },
            minWidth: 200
        }, {
            field: 'ReturnBy',
            headerName: 'Return by',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ReturnBy ? "".concat(row === null || row === void 0 ? void 0 : row.ReturnBy) : '-'; },
            minWidth: 200
        }, {
            field: 'TotalReturnQty',
            headerName: 'Total return qty',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.TotalReturnQty ? "".concat(row === null || row === void 0 ? void 0 : row.TotalReturnQty) : '-'; },
            minWidth: 200
        }, {
            field: 'TotalCost',
            headerName: 'Total cost.',
            valueFormatter: function (val, row) {
                var _Number;
                return val ? (_Number = Number(val)) === null || _Number === void 0 ? void 0 : _Number.toFixed(2) : '-';
            },
            minWidth: 200
        }, {
            field: 'ServiceAdvisor',
            headerName: 'Service advisor',
            valueFormatter: function (value, row) {
                var _row$ServiceAdvisor;
                return (_row$ServiceAdvisor = row === null || row === void 0 ? void 0 : row.ServiceAdvisor) !== null && _row$ServiceAdvisor !== void 0 ? _row$ServiceAdvisor : '';
            },
            minWidth: 200
        }, {
            field: 'Status',
            headerName: 'Status',
            renderCell: function (params) {
                var _params$row, _params$row$Status, _params$row2, _params$row3;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    alignItems: 'center',
                    height: '100%'
                }, params !== null && params !== void 0 && (_params$row = params.row) !== null && _params$row !== void 0 && _params$row.Status ? /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$row$Status = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.Status) !== null && _params$row$Status !== void 0 ? _params$row$Status : '-',
                    size: "small",
                    variant: "outlined",
                    id: 'status',
                    sx: {
                        borderRadius: 2,
                        px: 1,
                        fontWeight: 500,
                        fontSize: 12,
                        color: 'black'
                    },
                    icon: (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.Status) == 'Cancelled' ? /*#__PURE__*/ React.createElement(Box, {
                        height: 8,
                        width: 8,
                        borderRadius: 10,
                        bgcolor: "red"
                    }) : undefined
                }) : /*#__PURE__*/ React.createElement(Typography, null, '-'));
            },
            minWidth: 200
        }
        // {
        //     type: 'actions',
        //     field: 'actions',
        //     headerName: '',
        //     // getActions(params) {
        //     //     const menuFeatures = cloneDeep(storedMenuFeatures);
        //     //     const list = menuFeatures?.filter((data: any) => !(data.Name == 'CancelWPI'))
        //     //     const data: ResponseArray = params?.row?.Status === WorkPurchaseInvoiceStatusEnum?.Draft || params?.row?.Status === WorkPurchaseInvoiceStatusEnum?.PendingApproval || params?.row?.Status === WorkPurchaseInvoiceStatusEnum?.Rejected
        //     //         ? storedMenuFeatures
        //     //         : list ?? []
        //     //     return data?.map((data) => (
        //     //         <GridActionsCellItem
        //     //             label={data?.DisplayName}
        //     //             icon={getIcon(data?.Name)}
        //     //             id={"action-icon"}
        //     //             showInMenu
        //     //             onClick={async (e) => {
        //     //                 if (data?.Name == 'CancelWPI') {
        //     //                     handleRowCancelClick(params?.row?.id)
        //     //                 }
        //     //             }}
        //     //             sx={{
        //     //                 fontSize: 14,
        //     //                 [`& .MuiListItemIcon-root`]: { minWidth: 24 }
        //     //             }}
        //     //         />
        //     //     ))
        //     // },
        //     minWidth: 50,
        // }
    ];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isLoadingState([SpareIssueReturnKeys.Paging]) && /*#__PURE__*/ React.createElement(LinearProgress, {
        sx: {
            mt: 0.6
        }
    }), isDesktop && /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        paddingLeft: 1,
        borderBottom: '1px solid #DEE4EB'
    }, /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        sx: {
            width: "100%",
            paddingX: 1
        },
        tabVariant: "standard",
        showTabIndicator: true,
        bgColorApply: true
    })), /*#__PURE__*/ React.createElement(HeaderCatalogPageComponent
    // handleClickFilterIcon={handleClickFilterIcon}
    , {
        selectedMenuItem: selectedListVariant,
        menus: viewTypeOptions.length > 0 ? viewTypeOptions : undefined,
        onSelectMenu: handleSelectMenu,
        activeView: activeView,
        onToggleView: onToggleViewChange,
        totalCount: (_crud$SpareIssueRetur = crud[SpareIssueReturnKeys.Paging]) === null || _crud$SpareIssueRetur === void 0 ? void 0 : _crud$SpareIssueRetur.count,
        onClickCreateModule: function () {
            navigate('/createSpareIssueReturn?mode=edit');
        },
        createButtonText: "New",
        isCreateButton: true,
        moduleName: ESystemName.SpareIssueReturn,
        pagingKey: SpareIssueReturnKeys.Paging
    }), activeView === 'list' && isDesktop && /*#__PURE__*/ React.createElement(Box, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: SpareIssueReturnKeys.Paging,
        columns: customActionColumns,
        getPagingData: SPRPagingAPICall,
        pagingAPIRequest: getRequest(),
        dataGridProps: {
            onCellClick: function (params) {
                if (!(params.field === 'actions')) {
                    handleRowClick(params === null || params === void 0 ? void 0 : params.id);
                }
            },
            disableColumnMenu: false,
            initialState: {
                pinnedColumns: {
                    left: ['DocumentNumber']
                }
            }
        }
    })), (activeView === 'grid' || IS_MOBILE) && /*#__PURE__*/ React.createElement(Box, {
        py: 2
    }, /*#__PURE__*/ React.createElement(CardView, {
        pagingApiCall: SPRPagingAPICall,
        pagingKey: SpareIssueReturnKeys.Paging,
        pagingRequest: getRequest(),
        pageSize: 20,
        cardMapper: function (data) {
            return {
                id: "card-".concat(data.id),
                docNo: data.RegNo,
                title: dateFormate(data.DocumentDate),
                statusName: data.Status,
                details: [{
                        label: "Issue return no.:",
                        value: data === null || data === void 0 ? void 0 : data.DocumentNumber
                    }, {
                        label: "Return by:",
                        value: data === null || data === void 0 ? void 0 : data.ReturnBy
                    }, {
                        label: "Doc date:",
                        value: data === null || data === void 0 ? void 0 : data.DocumentDate
                    }, {
                        label: "Total return qty:",
                        value: data === null || data === void 0 ? void 0 : data.TotalReturnQty
                    }, {
                        label: "Total cost:",
                        value: data === null || data === void 0 ? void 0 : data.TotalCost
                    }]
            };
        },
        callIconVisibleFor: 'Return by:'
    })));
};
export default SpareIssueReturn;
